module.exports = __webpack_public_path__ + "img/group_receipt.fe8a6f83.svg";